export default __webpack_public_path__ + "static/media/logo-fantom_mobile.fae97122.svg";